<template>
  <nav class="navbar navbar-expand-lg navbar-light bg-light p-0" id="top_menu">
    <div class="container-xl p-0 ps-sm-3 pe-sm-3">
      <a class="navbar-brand" href="/">
        <img src="./assets/logo.png">
        <div>Reti monitoraggio della PCR</div>
      </a>

			<button class="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbar" aria-controls="navbar" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
			<div class="navbar-collapse justify-content-end collapse" id="navbar" style="">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
						<router-link to="licenza" class="nav-link">
							Licenza dei dati
						</router-link>
					</li>
					<li class="nav-item">
						<a href="/api/apidocs/index.html" class="nav-link">
							Accesso tramite API
						</a>
					</li>
					<li class="nav-item">
						<router-link to="attribuzioni" class="nav-link">
							Attribuzioni
						</router-link>
					</li>
        </ul>
      </div>
    </div>
  </nav>

</template>

<style scoped lang="scss">
	.navbar {
		background-color: #fff;
		border-bottom: solid 2px #dee2de;
		
		.icon-bar {
			color: dee2de;
		}
		.nav-item {
			height: 50px;
			a {
				height: 50px;
				padding-top: 10px;
			}
		}

		.navbar-brand {
			font-weight: bold;
			color: #0067b1;
			padding: 0;
			>div{
				padding-top: 10px;
				padding-left: 5px;
			}
			img {
				height: 50px;
				float: left;
				margin-right: 5px;
			}
		}
	}

</style>
